module.exports = __webpack_public_path__ + "img/xw-logo.b78fd325.png";